import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket'
import AvTimerOutlinedIcon from '@mui/icons-material/AvTimerOutlined'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import Co2OutlinedIcon from '@mui/icons-material/Co2Outlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import MapOutlinedIcon from '@mui/icons-material/MapOutlined'
import NoteOutlinedIcon from '@mui/icons-material/NoteOutlined'
import { Box } from '@mui/material'
import IconInfo from 'components/Bookings/Confirmation/IconInfo'
import { format, formatDistanceStrict } from 'date-fns'
import React from 'react'

interface Props {
  data: any
}

const StatusCompleted: React.FC<Props> = (props) => {
  const { data } = props
  const Reply = () => {
    return (
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ maxWidth: '50%' }}>
          {data?.when && (
            <IconInfo
              Icon={CalendarTodayOutlinedIcon}
              title="when"
              value={format(new Date(data?.when), 'MMMM eo yyyy HH:mm')} //TODO: correct formatting
            />
          )}
          {data?.pickup.addressLine1 && (
            <IconInfo
              Icon={LocationOnOutlinedIcon}
              title="from"
              value={data?.pickup.addressLine1}
            />
          )}
          {data?.dropOff.addressLine1 && (
            <IconInfo
              Icon={LocationOnOutlinedIcon}
              title="to"
              value={data?.dropOff.addressLine1}
            />
          )}
          {data?.specialInstructions && (
            <IconInfo
              Icon={NoteOutlinedIcon}
              title="Special Instructions"
              value={data?.specialInstructions}
            />
          )}
          {data?.flightDetails?.flightNumber && (
            <IconInfo
              Icon={AirplaneTicketIcon}
              title="flight number"
              value={data?.flightDetails?.flightNumber}
            />
          )}
          {data?.journeyTime && (
            <IconInfo
              Icon={AvTimerOutlinedIcon}
              title="journey time"
              value={formatDistanceStrict(0, data?.journeyTime * 1000)}
            />
          )}
          {data?.journeyDistance > 0 && (
            <IconInfo
              Icon={MapOutlinedIcon}
              title="distance"
              value={data?.journeyDistance}
            />
          )}
        </Box>
        <Box sx={{ maxWidth: '50%' }}>
          {data?.bookingReference && (
            <IconInfo
              Icon={InfoOutlinedIcon}
              title="booking reference"
              value={data?.bookingReference}
            />
          )}
          {data?.jobReference && (
            <IconInfo
              Icon={InfoOutlinedIcon}
              title="job reference"
              value={data?.jobReference}
            />
          )}

          {data?.co2Emmissions > 0 && (
            <IconInfo
              Icon={Co2OutlinedIcon}
              title="co2 emmissions"
              value={data?.co2Emmissions}
            />
          )}
        </Box>
      </Box>
    )
  }

  return <Reply />
}

export default StatusCompleted
